import { useNavigate } from "react-router-dom";
import { Card, Typography, Box } from "@mui/material";
import {
  CommonButton,
  HcccCard,
} from "../../common/StyledComponents/StyledFields";
import EmptyPage from "../../common/emptyPages/emptyPage";
import {
  apiRequest,
  getUserName,
} from "../../../infrastructure/backendService";
import { useEffect, useState } from "react";
import apiPath from "../../../config/apiPaths.json";
import { isNil, isNull } from "lodash";
import styles from "../devotee.module.scss";

const TimeToDonate = (): JSX.Element => {
  const navigate = useNavigate();
  const [date, setDate] = useState<string | null>(null);

  useEffect(() => {
    apiRequest({
      endpoint: apiPath.timeTodonateStock,
      includeToken: true,
      method: "GET",
      params: {
        username: getUserName(),
      },
    })
      .then((res) => {
        setDate(res.data.lastStockDonationDate);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDonateButton = (): void => {
    navigate("/donations");
  };

  const emptyPageButton = (): React.ReactElement => {
    return (
      <div>
        <CommonButton onClick={handleDonateButton}>Donate</CommonButton>
      </div>
    );
  };

  const timeToDonateStock = () => {
    return (
      <div className={styles.cardContainer}>
        <Typography component={"p"} className={styles.text}>
          It's Time to donate Stock as your last donation of stock is on {date}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "20px",
          }}
        ></Box>
      </div>
    );
  };

  const renderWithData = () => {
    return <div className={styles.stockDonate}>{timeToDonateStock()}</div>;
  };

  const renderEmptyData = () => {
    const  typographyText =
      "Please Contact Temple Manger at Phone: +1 (925) 449 6255";

   const parts = typographyText.split(" at ");

    return (
      <EmptyPage
        imgUrl="./images/TimeDonateStock.svg"
        typographyText={
         <div>
           {parts[0]} at <br />
           <b>{parts[1]}</b>
         </div>
       }
      />
    );
  };
  return (
    <HcccCard className={styles.stocksMainContainer}>
      <Typography className={styles.header}>
        Time to donate Stock
      </Typography>
      {!isNull(date) || !isNil(date) ? renderWithData() : renderEmptyData()}
    </HcccCard>
  );
};

export default TimeToDonate;
